import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Cookie, X } from 'lucide-react';
import Cookies from 'js-cookie';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already made a choice
    const consent = Cookies.get('orcsys-cookie-consent');
    if (!consent) {
      // Add a small delay before showing the banner for a smoother experience
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    Cookies.set('orcsys-cookie-consent', 'accepted', { expires: 365 });
    setIsVisible(false);
    //console.log('Cookies accepted');
  };

  const handleDecline = () => {
    Cookies.set('orcsys-cookie-consent', 'declined', { expires: 365 });
    setIsVisible(false);
    //console.log('Cookies declined');
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ type: "spring", stiffness: 100, damping: 20 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-3 md:p-6"
        >
          <motion.div
            className="mx-auto max-w-7xl"
            initial={{ scale: 0.95 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.1 }}
          >
            <div className="relative overflow-hidden rounded-xl bg-white/98 backdrop-blur-lg border border-slate-200/50 shadow-lg">
              <div className="px-4 py-4 sm:px-6">
                <div className="flex flex-col sm:flex-row sm:items-center gap-4">
                  <div className="flex items-start sm:items-center gap-3">
                    <div className="flex-shrink-0 mt-1 sm:mt-0">
                      <motion.div
                        initial={{ rotate: 0 }}
                        animate={{ rotate: 360 }}
                        transition={{ duration: 1, delay: 0.5 }}
                      >
                        <Cookie className="h-5 w-5 sm:h-6 sm:w-6 text-orcsys-500" />
                      </motion.div>
                    </div>
                    <p className="text-sm text-slate-700">
                      Nous utilisons des cookies pour améliorer votre expérience sur notre site. En continuant à naviguer, vous acceptez notre utilisation des cookies.{" "}
                      <a 
                        href="/confidentialite" 
                        className="text-orcsys-500 hover:text-orcsys-600 underline font-medium"
                        onClick={(e) => e.stopPropagation()}
                      >
                        En savoir plus
                      </a>
                    </p>
                  </div>
                  <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-2 sm:gap-3 sm:ml-4">
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleDecline}
                      className="px-4 py-2.5 text-sm font-medium text-slate-700 hover:text-slate-900 bg-white border border-slate-200 rounded-lg hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orcsys-500 transition-colors"
                    >
                      Refuser
                    </motion.button>
                    <motion.button
                      whileHover={{ scale: 1.02 }}
                      whileTap={{ scale: 0.98 }}
                      onClick={handleAccept}
                      className="px-4 py-2.5 text-sm font-medium text-white bg-orcsys-500 rounded-lg hover:bg-orcsys-600 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orcsys-500 transition-colors"
                    >
                      Accepter
                    </motion.button>
                  </div>
                </div>
              </div>
              <motion.div
                className="absolute bottom-0 left-0 right-0 h-1 bg-orcsys-100"
                initial={{ scaleX: 0, transformOrigin: "left" }}
                animate={{ scaleX: 1 }}
                transition={{ duration: 10, ease: "linear" }}
              />
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default CookieConsent; 